import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Grid from "@material-ui/core/Grid";

import Divider from "@material-ui/core/Divider";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {BotonAccionAbrirModal, TituloHeaderModal} from "../../../Include/MiniComponents/GlobalComponent";
import {CONFIG} from "../../../../settings/Config/Config";
import {Dropbox} from 'dropbox';
import {createFilterOptions} from "@material-ui/lab/Autocomplete";
import {CargaCFDIService} from "../../../../services/CargaCFDIService/CargaCFDIService";
import Typography from "@material-ui/core/Typography";
import {KeyboardDateTimePicker} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import {TimbradoFacturacionExtService} from "../../../../services/TimbradoFacturacionExtService/TimbradoFacturacionExtService";


class ModalCancelarCFDI extends Component {
	
	state = {};
	
	showSnackBars = this.props.showSnackBars;
	
	constructor(props) {
		super(props);
		
		this.state = {
			modal: {
				open: false
			},
			tipo: props.tipo,
			id_venta: (props.item || []).id_venta,
			numero_pedido: (props.item || []).numero_pedido,
			
			id_facturacion_cfdi: (props.item || '').id_facturacion_cfdi,
			id_facturacion_cfdi_parcial: (props.item || '').id_facturacion_cfdi_parcial,
			uuid: (props.item || '').uuid,
			fecha_cancelacion: null,
			id_cat_cancelacion_cfdi: '',
			folio_fiscal_sustituye: '',
			listar_cat_cancelacion_cfdi: [],
			sustituye: false,
			id_empresa: (props.item || 11).id_empresa,
			id_empresa_sucursal: (props.item || 11).id_empresa_sucursal
		};
		
	}
	
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}))
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
		console.log(this.state, props);
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	save = () => {
		console.log("THIS.STATE: ", this.state);
		
		try {
			
			if (!this.state.id_cat_cancelacion_cfdi) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Motivo de cancelación.'
				})
			}
			if (this.state.sustituye) {
				if (!this.state.folio_fiscal_sustituye) {
					throw Object({
						status: false, mensaje: 'Campo requerido: Folio fiscal que sustituye.'
					})
				}
			}
			
			TimbradoFacturacionExtService.CancelacionCFDI(this.state).then((response) => {
				this.closeModal();
				this.props.RefreshList();
				this.props.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
			
		} catch (e) {
			console.error(e);
			this.props.showSnackBars('error', e.mensaje);
		}
	};
	
	add = () => {
		const {item} = this.props;
		console.log(this.props);
		this.setState({
			activo: true,
			jsonXML: '',
			uuid: item.uuid || '',
			id_cat_cancelacion_cfdi: item.id_cat_cancelacion_cfdi || '',
			fecha_cancelacion: item.fecha_cancelacion || null,
			sustituye: !!item.folio_fiscal_sustituye,
			folio_fiscal_sustituye: item.folio_fiscal_sustituye || '',
			id_facturacion_cfdi: item.id_facturacion_cfdi || '',
			id_facturacion_cfdi_parcial: item.id_facturacion_cfdi_parcial,
			observaciones: ''
		});
		this.ListaCancelacionCFDI();
		this.open();
	};
	
	edit = () => {
		const {item} = this.props;
		console.log(this.props);
		this.setState({
			activo: (item.activo === 1),
		});
		this.open();
	};
	
	view = () => {
		const {item} = this.props;
		console.log(this.props);
		this.setState({
			//abreviatura: item.abreviatura || '',
			activo: (item.activo === 1),
		});
		this.open();
	};
	
	getBase64 = (e, dropzone) => {
		return new Promise((resolve) => {
			const accessToken = CONFIG.DROPBOX_TOKEN;
			let files;
			if (dropzone) {
				files = e;
			} else {
				console.log(e.target);
				files = e.target.files;
			}
			
			const dbx = new Dropbox({
				accessToken,
				fetch
			});
			console.log("DROPBOX: ", dbx, files[0], files[0].name);
			dbx.filesUpload({path: '/' + files[0].name, contents: files[0]})
				.then(function (response) {
					console.log("DROPBOX UPLOAD: ", response);
					resolve(true);
				})
				.catch(function (error) {
					console.error(error);
				});
		});
	};
	
	is_view = () => {
		return this.props.tipo === 'view';
	};
	
	is_edit = () => {
		return this.props.tipo === 'edit';
	};
	
	is_add = () => {
		return this.props.tipo === 'add';
	};
	
	ListaCancelacionCFDI = () => {
		CatService.ListCancelacionCFDIFac().then((response) => {
			this.setState({
				listar_cat_cancelacion_cfdi: response.data,
			});
		}).catch((error) => {
			this.setState({
				listar_cat_cancelacion_cfdi: []
			});
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	render() {
		
		const filterOptions = createFilterOptions({
			matchFrom: 'start',
			stringify: option => option.rfc,
		});
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			case 'view':
				funcion = this.view;
				break;
			default:
				funcion = () => {
				};
		}
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_cat_sexo}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'sm'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						Cancelar CFDI
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={2}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Typography className={'margin-15-B'} style={{color: 'gray', opacity: '0.8'}}>
									Selecciona el motivo de cancelación y si tiene un folio fiscal relacionado puedes agregarlo.
								</Typography>
							</Grid>
							
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<TextField
									select
									fullWidth
									required
									margin="none"
									onChange={this.handleChange}
									SelectProps={{
										native: true,
										MenuProps: {
											className: '',
										},
									}}
									name="id_cat_cancelacion_cfdi"
									label="Motivo de la cancelación"
									value={this.state.id_cat_cancelacion_cfdi}
								>
									<option key={0} value={''}>&nbsp;</option>
									{this.state.listar_cat_cancelacion_cfdi.map(option => (
										<option key={option.id_cat_cancelacion_cfdi} value={option.id_cat_cancelacion_cfdi}>
											{option.descripcion ? option.cancelacion_cfdi + " - " + option.descripcion : option.cancelacion_cfdi}
										</option>
									))}
								</TextField>
							</Grid>
							
							{Number(this.state.id_cat_cancelacion_cfdi) === 1 ? (
								<Grid item xs={12} sm={12} md={5} lg={5} xl={5} className={'text-center'}>
									<FormGroup row className={'margin-3-L'}>
										<FormControlLabel
											control={
												<Checkbox
													type="checkbox"
													name='sustituye'
													checked={this.state.sustituye}
													onChange={this.handleChange}
													value="sustituye"
													color="primary"
													disabled={this.is_view()
													}/>
											}
											label={'CFDI que sustituye'}
										/>
									</FormGroup>
								</Grid>
							):null}
							
							{this.state.sustituye ? (
								<Grid xs={12} sm={12} md={12} lg={12} xl={12}>
									<TextField
										name="folio_fiscal_sustituye"
										label="Folio fiscal que sustituye"
										type="text"
										fullWidth
										value={this.state.folio_fiscal_sustituye}
										onChange={this.handleChange}
									/>
								</Grid>
							) : null}
							
							<Grid xs={12} sm={12} md={12} lg={12} xl={12}>
								<TextField
									multiline
									name="observaciones"
									label="Observaciones"
									type="text"
									fullWidth
									rows={3}
									value={this.state.observaciones}
									onChange={this.handleChange}
								/>
							</Grid>
							
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<br/>
								<br/>
							</Grid>
						
						
						</Grid>
					
					</DialogContent>
					
					
					<DialogActions>
						
						<Fragment>
							<Button onClick={this.close} color="primary">
								Cerrar
							</Button>
							<Button onClick={this.save} color="primary">
								Confirmar
							</Button>
						</Fragment>
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalCancelarCFDI.propTypes = {
	componente: PropTypes.element,
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalCancelarCFDI;

